import { render, staticRenderFns } from "./ValidationType.vue?vue&type=template&id=846dbed4&lang=pug"
import script from "./ValidationType.vue?vue&type=script&lang=js"
export * from "./ValidationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('846dbed4')) {
      api.createRecord('846dbed4', component.options)
    } else {
      api.reload('846dbed4', component.options)
    }
    module.hot.accept("./ValidationType.vue?vue&type=template&id=846dbed4&lang=pug", function () {
      api.rerender('846dbed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profiling/ValidationType.vue"
export default component.exports